<template>
  <div>
    <vue-portal to="hrsys-navbar-actions">
      <div class="flex">
        <base-header-title :title="$t('modules.home')"/>
      </div>
    </vue-portal>
    <div class="view-container h-full">
      <base-loader :loading="loadCalendar">
        <Calendar :events="list" @toggle="getMonthData" @dateClick="createTimecard" @itemClick="createTimecard"/>
      </base-loader>
    </div>
  </div>

</template>

<script>
  import Holidays from "../../services/Holidays";
  import Calendar from "../../components/Calendar"
  import * as moment from 'moment'
  import BaseLoader from "../../components/_base-loader";
  import EventBus from "../../utilities/eventBus";

  export default {
    components: {
      BaseLoader,
      Calendar
    },
    data () {
      return {
        list: [],
        loadCalendar: false
      }
    },
    methods: {
      getMonthData (date) {
        this.loadCalendar = true;
        let month = moment(date).format('M');
        let year = moment(date).year();
        Holidays.getMonthData({month, year}).then(response => {
          this.list = response.data
        }).catch(e => {
          this.$notificationService.error(e.message)
        }).finally(() => this.loadCalendar = false)
      },
      createTimecard(date) {
        if (date && date.startDate) {
          EventBus.$emit('createTimecard', date.startDate)
        } else {
          EventBus.$emit('createTimecard', date)
        }
      }
    },
    mounted() {
      this.getMonthData()
      EventBus.$on('timecardDone', () => this.getMonthData())
    },
    beforeDestroy() {
      EventBus.$off('timecardDone', () => this.getMonthData())
    }
  }
</script>

<style lang="scss">
</style>
